// Zoom level when setting view to a location
export const VIEW_ZOOM = 13;

export const ELEVATION_HEIGHT = 200;

export const DIMMED_MARKER_OPACITY = 0.3;
